/**
 * Created by YYVZB on 2017/11/22.
 */

export const marquee = {
  data() {
    return {
      currenTranslateY: 0,
      height: '',
      length: 0,
      currentIndex: 0,
      noAnimate: false,
      direction: 'up',
      duration: 200,
      timer: null,
      cloneNode: null,
      interval: 1000
    }
  },
  methods: {
    // 滚动
    destroy() {
      this.cloneNode = null
        this.timer && clearInterval(this.timer)

    },
    init() {
        this.destroy()
        // let nodeEle = document.querySelect('.ul_box')
        // if (this.cloneNode) {
        //     this.$refs.box.removeChild(this.cloneNode)
        // }
        console.log(this.cloneNode)
        this.cloneNode = null
        console.log(this.$refs.box.children.length)
        let firstItem = this.$refs.box.firstElementChild
        if (!firstItem) {
            return false
        }
        this.length = this.$refs.box.children.length

        this.height = this.itemHeight || firstItem.offsetHeight

        if (this.direction === 'up') {
            this.cloneNode = firstItem.cloneNode(true)
            this.$refs.box.appendChild(this.cloneNode)
        } else {
            this.cloneNode = this.$refs.box.lastElementChild.cloneNode(true)
            this.$refs.box.insertBefore(this.cloneNode, firstItem)
        }
        return true
    },
    start() {
        if (this.direction === 'down') this.go(false)
        this.timer = setInterval(() => {
            if (this.direction === 'up') {
                this.currentIndex += 1
                this.currenTranslateY = -this.currentIndex * this.height
                console.log(this.height)
            } else {
                this.currentIndex -= 1
                this.currenTranslateY = -(this.currentIndex + 1) * this.height
            }
            if (this.currentIndex === this.length) {

                setTimeout(() => {
                    this.go(true)
                }, this.duration)
            } else if (this.currentIndex === -1) {
                setTimeout(() => {
                    this.go(false)
                }, this.duration)
            } else {
                this.noAnimate = false
            }
        }, this.interval + this.duration)
    },
    go(toFirst) {
        this.noAnimate = true
        if (toFirst) {
            this.currentIndex = 0
            this.currenTranslateY = 0
        } else {
            this.currentIndex = this.length - 1
            this.currenTranslateY = -(this.currentIndex + 1) * this.height
        }
    },
  },
  beforeDestroy(){
    this.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/Mixin/marquee.js